import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { Pfmspends, PfmspendsMaintanence } from './pfmspends.model';
import { environment } from 'src/environments/environment';
import moment from 'moment';
@Injectable()
export class PfmspendsService implements BaseFpxDataService<any> {
 constructor(private _httpProvider : HttpProviderService) { }
  create(payload: Pfmspends): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/pfmspends');
      let bodyContent = {"pfmspends":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  findByKey(key: Pfmspends): FindByKeyFn<Pfmspends|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/pfmspends/{totalExpense}');
       httpRequest.addPathParameter('totalExpense', key.totalExpense);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.pfmspends ?? null),catchError((err:any) => {
              return of(null)
            }));

    };
  }

  modify(payload: Pfmspends): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/pfmspends/{totalExpense}');
       httpRequest.addPathParameter('totalExpense', payload.totalExpense);
     httpRequest.setMethod('PUT');
      let bodyContent = {"pfmspends":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }


 findAll(criteriaQuery: CriteriaQuery): FindAllFn<Pfmspends[]> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/pfmspends');
      httpRequest.setMethod('GET');
      if(criteriaQuery.getQueryparam('period')){
        httpRequest.addQueryParameter('period',criteriaQuery.getQueryparam('period'));
      }else{
        let date:any = moment().format('DD/MM/YYYY').split('/');
        httpRequest.addQueryParameter('period', date[2]+"-"+date[1]);
      }
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res: IHttpSuccessPayload<PfmspendsMaintanence>) =>
              res.body?.pfmspends
          )
        );
    };
  }


     lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource('/pfmspends');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
	  httpCriteria.setPaginationCriteria('1', 10);
	  httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
	  searchText: key.searchText ?? '',
	  });
	  httpRequest.setCriteriaQuery(httpCriteria);

      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }
}
